import { Icon } from '@iwoca/orion';
import { t } from '@lingui/macro';
import clsx from 'clsx';
import { useAmplitude } from 'hooks/useAmplitude';
import { TNotification } from 'lendingApi/notifications';
import { useNavigate } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './Notification.module.css';

type TProps = {
  notification: TNotification;
  onMarkAsRead: (notificationId: string) => void;
};

export const Notification = ({ notification, onMarkAsRead }: TProps) => {
  const navigate = useNavigate();
  const { trackEvent } = useAmplitude();
  const applicationId = notification.application_id;
  const isOffered = notification.status === 'offered';
  const isRead = notification.read_time;

  const renderText = () => {
    if (isOffered) {
      return t`You've got an offer for ${notification.company_name}.`;
    }

    return t`Upload documents to progress your app with ${notification.company_name}.`;
  };

  const handleOnClick = async () => {
    await onMarkAsRead(notification.notification_id);

    if (isOffered) {
      trackEvent(AMPLITUDE_EVENTS.notificationsCTASelected, {
        'Notification type': 'Offered',
      });
      navigate(PATH_NAMES.application({ applicationId }));
      return;
    }

    trackEvent(AMPLITUDE_EVENTS.notificationsCTASelected, {
      'Notification type': 'Docs required',
    });
    navigate(PATH_NAMES.applicationDocuments({ applicationId }));
  };

  return (
    <button
      className={clsx(styles.notification, {
        [styles.notificationRead]: isRead,
      })}
      data-testid="notification-item"
      onClick={handleOnClick}
    >
      <div
        className={clsx(styles.iconContainer, {
          [styles.offered]: isOffered,
        })}
      >
        <Icon
          icon={isOffered ? 'partyPopper' : 'filePlus'}
          className={styles.icon}
        />
      </div>
      <p className={styles.text}>{renderText()}</p>
      <div className={styles.dot} />
    </button>
  );
};
